import type { ProcessingError } from '@xbcb/api-gateway-client';
import { createModalKey } from '../../types';
import { ModalKey } from '@xbcb/ui-types';

export type ProcessingErrorBase = Omit<ProcessingError, 'updated' | 'operator'>;

export const processingErrorsModalKey: ModalKey =
  createModalKey('PROCESSING_ERRORS');
